
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { DebugErrorBoundary } from './components/DebugErrorBoundary';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

console.log("App initializing..."); 

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <DebugErrorBoundary>
        <BrowserRouter>
          <App />
        </BrowserRouter>
    </DebugErrorBoundary>
  </React.StrictMode>
);
